import {Injectable} from '@angular/core';
import {of} from 'rxjs';
import {IPaginationParams} from 'src/utils/declarations';
import {ApiService} from 'app/shared/services/api.service';

interface GetNotificationsParams extends IPaginationParams {
  read?: boolean;
  token: string;
}

interface ReadAllNotificationsParams {
  ids: number[];
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private apiService: ApiService) {
  }

  getNotifications = (params: GetNotificationsParams) => {
    const {page, per_page, read = false, token} = params;
    return this.apiService.get(
      '/message/list',
      !read ? {page, per_page, read} : {page, per_page},
      {
        Authorization: `Bearer ${token}`,
      }
    );
  };

  readAllNotifications = (params: ReadAllNotificationsParams) => {
    const {ids, token} = params;

    return this.apiService.post(
      '/message/reads',
      {messages: ids},
      {
        Authorization: `Bearer ${token}`,
      }
    );
  };

  readOneNotification = (params: { id: number; token: string }) => {
    const {id, token} = params;

    return this.apiService.get(
      `/message/read/${id}`,
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
  };

  createNotification = (data: any) => {
    return of({
      type: data.type,
      id: '9',
      text: data.text,
      title: data.title,
      subtitle: data.subtitle,
      date: new Date(),
      read: false,
    });
  };
}
